module.exports = "//docs.gtimg.com/slide/img/framework/frame/components/animation-editor/images/animation_icon-b00459.svg";